import { setIsLoading } from 'apps/web_forms/slices/formSlice';

const actionTimeoutMiddleware = (store) => {
  let frameRequest = null;
  let lastActionTime = Date.now();

  const checkIdleTime = () => {
    const { isLoading } = store.getState().form;
    const currentTime = Date.now();

    if (isLoading && currentTime - lastActionTime > 1000) {
      store.dispatch(setIsLoading(false));
      frameRequest = null; // Stop the rAF loop
    } else {
      frameRequest = requestAnimationFrame(checkIdleTime); // Continue the rAF loop
    }
  };

  return (next) => (action) => {
    const { isLoading } = store.getState().form;

    if (isLoading) {
      lastActionTime = Date.now(); // Update the last action time
      if (!frameRequest) {
        frameRequest = requestAnimationFrame(checkIdleTime); // Start the rAF loop if not already started
      }
    }
    // Dispatch the action
    next(action);
  };
};

export default actionTimeoutMiddleware;